import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import CashflowModelInputs from '../../../CashflowModel/CashflowModelInputs';
import ResultsTable from '../../../CashflowModel/ResultsTable';

/**
 * Off-screen (parent positions) harness to call the same imperative CSV APIs as
 * {@link ../../../CashflowModel/index.js} without changing that screen.
 */
const TearsheetCashflowCsvHarness = forwardRef(
  ({ normalizedResult, csvExportPrefillValues }, ref) => {
    const refResultsTable = useRef(null);
    const refInputs = useRef(null);

    useImperativeHandle(
      ref,
      () => ({
        getFullCashflowCsvMatrix() {
          const modelCsv =
            refResultsTable.current?.generateCsvData?.() ?? [];
          const inputsCsv =
            refInputs.current?.generateCsvData?.() ?? [];
          return [...modelCsv, [], [], ...inputsCsv];
        },
      }),
      []
    );

    const items = normalizedResult?.items;
    if (!items) {
      return null;
    }

    return (
      <Box aria-hidden={true}>
        <ResultsTable
          ref={refResultsTable}
          modelResults={items}
          cohortsRawData={normalizedResult.cohorts}
          roasVector={normalizedResult.roas_100_avg_6}
          kpiVectors={normalizedResult.kpis?.vectors}
        />
        <CashflowModelInputs
          ref={refInputs}
          csvExportMode
          csvExportPrefillValues={csvExportPrefillValues}
          onSubmit={() => {}}
          modelResults={items}
          roasVector={normalizedResult.roas_100_avg_6}
          onCustomerChange={() => {}}
        />
      </Box>
    );
  }
);

TearsheetCashflowCsvHarness.displayName = 'TearsheetCashflowCsvHarness';

TearsheetCashflowCsvHarness.propTypes = {
  normalizedResult: PropTypes.object,
  csvExportPrefillValues: PropTypes.object,
};

export default TearsheetCashflowCsvHarness;
